import React, { useState } from "react";
import TeamVideoStatsCard from "components/TeamVideoStatsCard/TeamVideoStatsCard";
import CheckInStatsCard from "components/CheckInStatsCard";
import PeerRecognitionStatsCard from "components/PeerRecognitionStatsCard/PeerRecognitionStatsCard";
import NetThrivingScoreStatsCard from "components/NetThrivingScoreStatsCard/NetThrivingScoreStatsCard";
import SlideshowStatsCard from "components/SlideshowStatsCard/SlideshowStatsCard";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
  },
  mainRoot: {
    borderBottom: "1px solid #43434317",
  },
  content: {
    overflow: "hidden",
  },
  dialogContent: {
    height: "450px",
    maxHeight: "450px",
    overflow: "auto",
  },
  heading: {
    fontWeight: 500,
  },
  statsHeading: {
    fontSize: "0.9rem",
  },
};

export default ({ children, teamName, teamId }) => {
  const classes = styles;
  const [openDialog, setDialog] = useState(false);

  return (
    <>
      <div
        onClick={() => {
          setDialog(true);
        }}
      >
        {children}
      </div>
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootTeamStatsModalContainer",
        }}
        open={openDialog}
        showCloseIcon={false}
        onClose={() => setDialog(false)}
      >
        <div style={classes.mainRoot}>
          <div style={classes.root} className="modalHeader">
            <div>
              <h3 style={classes.heading}>{teamName}</h3>
            </div>
            <div>
              <h4 style={classes.statsHeading}>Team Statistics</h4>
            </div>
          </div>
        </div>
        <div style={classes.dialogContent} className="teamStatsModalContent">
          <Scrollbar>
            <div style={{ padding: "0 12px" }}>
              <div className="right-sidebar">
                <div className="timeline-right">
                  <NetThrivingScoreStatsCard team_id={teamId} />
                  <PeerRecognitionStatsCard team_id={teamId} />
                  <TeamVideoStatsCard
                    team_id={teamId}
                    showPublishVideo={false}
                  />
                  <CheckInStatsCard team_id={teamId} />
                  <SlideshowStatsCard team_id={teamId} showSlideshow={false} />
                </div>
              </div>
            </div>
          </Scrollbar>
        </div>
        <div className="modalAction">
          <Button
            onClick={() => {
              setDialog(false);
            }}
            buttonClass={"cancelButton"}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
